<template>
    <!-- AddAdminModel -->
    <div class="modal fade action-sheet" id="addAdminModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!add_admin">Edit</h5>
                    <h5 class="modal-title" v-if="add_admin">Add New</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addAdmin" :validation-schema="schema" ref="myForm">
                            <!-- <div class="form-group basic">
                                <label class="label" for="stay"><span>നിലവിൽ വരിക്കാരൻ ആണോ</span></label>
                                <select as="select" class="form-control custom-select" v-model="isSubscriber"
                                    name="isSubscriber" id="select4">
                                    <option value="Y">അതെ</option>
                                    <option value="N">അല്ല</option>
                                </select>
                            </div> -->
                            <!-- <div class="form-group basic">
                                <label class="label" for="stay"><span>നിലവിൽ മെമ്പർ ആണോ</span></label>
                                <select as="select" class="form-control custom-select" v-model="isMember" name="isMember"
                                    id="select4">
                                    <option value="Y">അതെ</option>
                                    <option value="N">അല്ല</option>
                                </select>
                                <input type="hidden" v-model="member_id" />
                            </div> -->
                            <!-- <div class="form-group basic typehead-div" v-if="isMember == 'Y'">
                                    <label class="label" for="text4b">Member</label>
                                    <v-select label="text" :filterable="true" class="form-control" v-model="member" :value="member"
                                        :options="member_list" @input="getTextList($event.target.value, 0)" @change="changeMember(member)">
                                        <template>
                                            type to search...
                                        </template>
</v-select>
<ErrorMessage name="member" class="error-feedback" />
</div> -->
                            <!-- Member or Not Member Selection -->
                            <div class="form-group basic">
                                <label class="label" for="isMember"><span>Member or Not Member</span><span class="text-danger">*</span></label>
                                <select class="form-control custom-select" v-model="isMember" name="isMember" id="isMember">
                                    <option value="">---Select---</option>
                                    <option value="Y">Member</option>
                                    <option value="N">Not Member</option>
                                </select>
                            </div>
                            
                            <!-- Member Dropdown (shown only if Member is selected) -->
                            <div class="form-group basic" v-if="isMember == 'Y' && this.user_level <= 5">
                                <div class="input-wrapper">
                                    <label class="label text-primary" for="member">Member<span class="text-danger">*</span></label>
                                    <Field as="select" class="form-control custom-select" id="member" name="member"
                                        v-model="member" @change="changeMember(member)">
                                        <option value="" selected>---Select---</option>
                                        <option v-for="member in members" v-bind:key="member.id" v-bind:value="member">
                                            {{ member.name }}
                                        </option>
                                    </Field>
                                </div>
                                <ErrorMessage name="member" class="error-feedback" />
                            </div>
                            
                            <!-- Name Field (shown only if Not Member is selected) -->
                            <div class="form-group basic" v-if="isMember == 'N'">
                                <label class="label" for="name">Name<span class="text-danger">*</span></label>
                                <Field name="name" type="text" class="form-control" v-model="name" placeholder="Name"
                                    autocomplete="off" />
                            </div>
                            <div class="form-group basic">
                                <label class="label" for="mobile">Mobile Number<span
                                        class="text-danger">*</span></label>
                                <Field name="mobile" type="text" :disabled="this.user_level == 6" class="form-control"
                                    v-model="mobile" placeholder="Mobile" autocomplete="off" />
                            </div>
                            <div class="form-group basic">
                                <label class="label" for="house_name">Address line 1 (Father name, House name)<span class="text-danger">*</span></label>
                                <Field name="house_name" type="text" class="form-control" v-model="house_name"
                                    placeholder="Address Line 1" autocomplete="off" />
                            </div>
                            <div class="form-group basic">
                                <label class="label" for="place">Address line 2 (Place, landmark)</label>
                                <Field name="place" type="text" class="form-control" v-model="place"
                                    placeholder="Address Line 2" autocomplete="off" />
                            </div>
                            <div class="form-group basic">
                                <label class="label" for="post"><span>Post</span><span
                                        class="text-danger">*</span></label>
                                <Field name="post" type="text" class="form-control" v-model="post" placeholder="Post"
                                    autocomplete="off" />
                            </div>
                            <div class="form-group basic">
                                <label class="label" for="pin">Pin<span class="text-danger">*</span></label>
                                <Field name="pin" type="number" class="form-control" v-model="pin" placeholder="pin"
                                    autocomplete="off" />
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label text-primary" for="district"> District <span
                                            class="text-danger">*</span></label>
                                    <Field as="select" class="form-control custom-select" id="district" name="district"
                                        v-model="district">
                                        <option value="" selected>---Select---</option>
                                        <option v-for="district in kerala_district_list" v-bind:key="district.name"
                                            v-bind:value="district.name">
                                            {{ district.name }}
                                        </option>
                                    </Field>
                                </div>
                                <ErrorMessage name="district" class="error-feedback" />
                            </div>
                            <!-- <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label text-primary" for="postal_type"> Postal Type <span
                                            class="text-danger">*</span></label>
                                    <Field as="select" class="form-control custom-select" id="postal_type" name="postal_type"
                                        v-model="postal_type">
                                        <option value="Postal" selected>Postal</option>
                                        <option value="Bundle" selected>Bundle</option>
                                    </Field>
                                </div>
                                <ErrorMessage name="postal_type" class="error-feedback" />
                            </div> -->

                            <!-- <div class="form-group basic">
                                <label class="label" for="receipt_number">Receipt Number<span
                                    class="text-danger">*</span></label>
                                <Field name="receipt_number" type="text" class="form-control" v-model="receipt_no"
                                    placeholder="Receipt Number" autocomplete="off" />
                            </div> -->
                            <!-- <div class="form-group basic" v-if="subscription_no">
                                <label class="label" for="subscription_number"><span>Subscription
                                        Number</span></label>
                                <Field name="subscription_number" :disabled="true" type="text" class="form-control" v-model="subscription_no"
                                    placeholder="Subscription Number" autocomplete="off" />
                            </div> -->
                            <div class="form-group" v-if="message">
                                <div v-if="message" class="error-feedback">
                                    {{ message }}
                                </div>
                            </div>

                            <div class="form-group basic row">
                                <button type="button" @click="handleButtonClick('save')"
                                    class="btn btn-primary btn-block btn-lg col mt-1" :disabled="loading"
                                    v-if="permissions.update && !renewal_btn">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>Save</span></button>
                                &nbsp;
                                <button type="button" @click="handleButtonClick('renew')"
                                    class="btn btn-info btn-block btn-lg col" :disabled="loading || !renewal_btn"
                                    v-if="permissions.update && editable_id && renewal_btn">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>Renew & Save</span></button>
                                <button type="button" class="btn btn-warning btn-block btn-lg"
                                    v-if="!permissions.update" @click="closeAddAdminModel">Close</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="section text-center mt-1" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    
    <!-- 1. Subscription Profile Details (for each subscription) -->
    <div class="subscriptions-wrapper" v-if="!loading_list">
        <div v-for="(member_list) in member_lists.data" v-bind:key="member_list.id" class="subscription-item">
            <div class="subscription-cards-container">
                <!-- Profile & Subscription Details Card -->
                <div class="profile-card card-item">
                    <!-- Collapsible Header -->
                    <div class="profile-header-toggle" @click.stop="toggleProfileDetails(member_list.id)">
                        <div class="header-content-expanded">
                            <div class="header-top-row">
                                <div class="header-left">
                                    <h6 class="subscription-number">
                                        {{ member_list.subscription_no ? member_list.subscription_no : 'New Subscription' }}
                                    </h6>
                                    <h5 class="subscriber-name">{{ member_list.name }}</h5>
                                </div>
                                <ion-icon :name="profileExpanded[member_list.id] ? 'chevron-up-outline' : 'chevron-down-outline'" 
                                          class="header-chevron-icon"></ion-icon>
                            </div>
                            
                            <!-- Subscription Details in Header (Compact Single Line) -->
                            <div class="header-subscription-grid">
                                <!-- Item 1: Expiry -->
                                <div class="grid-item">
                                    <span class="header-detail-label">Expiry:</span>
                                    <span class="header-detail-value">{{ member_list.expiry_date ? member_list.expiry_date : '--/--/----' }}</span>
                                </div>
                                <!-- Item 2: Status -->
                                <div class="grid-item">
                                    <span class="header-detail-label">Status:</span>
                                    <span class="badge badge-sm" :class="member_list.status == 'Active' ? 'badge-success' : member_list.status == 'Pending' ? 'badge-warning' : 'badge-danger'">
                                        {{ member_list.status }}
                                    </span>
                                </div>
                                
                                <!-- Item 3: Renewal (if exists) -->
                                <div class="grid-item" v-if="member_list.expiry_date">
                                    <span class="header-detail-label">Renewal:</span>
                                    <span class="badge badge-sm" :class="member_list.renewal_status == 'Renewed' ? 'badge-success' : member_list.renewal_status == 'Requested' ? 'badge-warning' : 'badge-danger'">
                                        {{ member_list.renewal_status }}
                                    </span>
                                </div>
                                <!-- Placeholder if no renewal but payment exists, to ensure alignment? No, grid auto flow is fine -->
                                <div class="grid-item" v-if="!member_list.expiry_date"></div>

                                <!-- Item 4: Payment -->
                                <div class="grid-item">
                                    <span class="header-detail-label">Payment:</span>
                                    <span class="badge badge-sm" :class="(member_list.payments.length ? member_list.payments[0].payment_status : '') == 'Paid' ? 'badge-success' : 'badge-danger'">
                                        {{ member_list.payments.length ? member_list.payments[0].payment_status : 'Unpaid' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Collapsible Profile Content -->
                    <div class="profile-content" v-show="profileExpanded[member_list.id]">
                        <!-- Personal Information Section -->
                        <div class="info-section">
                            <h6 class="section-title">Personal Information</h6>
                            <div class="info-grid">
                                <div class="info-row">
                                    <span class="info-label">Mobile</span>
                                    <span class="info-value">{{ member_list.mobile }}</span>
                                </div>
                                <div class="info-row">
                                    <span class="info-label">Address 1</span>
                                    <span class="info-value">{{ member_list.houseName }}</span>
                                </div>
                                <div class="info-row">
                                    <span class="info-label">Address 2</span>
                                    <span class="info-value">{{ member_list.place }}</span>
                                </div>
                                <div class="info-row">
                                    <span class="info-label">Post</span>
                                    <span class="info-value">{{ member_list.post }}</span>
                                </div>
                                <div class="info-row">
                                    <span class="info-label">Pin</span>
                                    <span class="info-value">{{ member_list.pinCode }}</span>
                                </div>
                                <div class="info-row">
                                    <span class="info-label">District</span>
                                    <span class="info-value">{{ member_list.district }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Action Buttons Section -->
                        <div class="action-section mt-3">
                            <div class="button-group">
                                <button type="button" @click="adminView(member_list, 'edit')" 
                                        class="btn btn-primary btn-sm flex-fill">
                                    <ion-icon name="create-outline"></ion-icon>
                                    Edit Address
                                </button>
                                <button type="button" v-if="member_list.renewal_status == 'Not Requested'"
                                        @click="adminView(member_list, 'renew')" 
                                        class="btn btn-success btn-sm flex-fill">
                                    <ion-icon name="refresh-outline"></ion-icon>
                                    Renew
                                </button>
                            </div>
                        </div>
                        
                        <!-- Payment Information Section -->
                        <!-- Payment Information Section (Compact & Mobile Friendly) -->
                        <div class="payment-section-wrapper mt-3">
                            <div class="compact-payment-card">
                                <div class="compact-card-body">
                                    <!-- Amount Display -->
                                    <div class="amount-display mb-3">
                                        <span class="amount-label">Amount</span>
                                        <span class="amount-value" :class="(member_list.payments.length ? member_list.payments[0].payment_status : '') == 'Paid' ? 'text-success' : 'text-danger'">₹{{ this.amount }}</span>
                                    </div>

                                    <!-- Paid Details -->
                                    <div v-if="(member_list.payments.length ? member_list.payments[0].payment_status : '') == 'Paid'">
                                        <div class="detail-row">
                                            <span class="detail-label">Payment Mode</span>
                                            <span class="detail-value">{{ member_list.payments[0].payment_mode }}</span>
                                        </div>
                                        <div class="detail-row">
                                            <span class="detail-label">Transaction ID</span>
                                            <span class="detail-value">{{ member_list.payments[0].payment_transaction_id }}</span>
                                        </div>
                                        <div class="mt-3" v-if="permissions.print_payment">
                                            <a :href="'https://guideportal.wisdomislam.org/donation/download-nerpatham-receipt/' + member_list.id" 
                                               class="btn btn-outline-primary btn-sm btn-block" download>
                                                <ion-icon name="download-outline"></ion-icon> Download Receipt
                                            </a>
                                        </div>
                                    </div>

                                    <!-- Unpaid Action -->
                                    <div v-else>
                                        <button type="button" class="btn btn-danger btn-block" @click="razorPay(member_list.id)">
                                            Pay Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                    <!-- \u003cdiv class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + member_list.id" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div> -->

                    <!-- Default Action Sheet Inset -->
                    <div class="modal fade action-sheet" :id="'actionSheetInset' + member_list.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Action</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">

                                        <!-- <li>
                                            <a :href="'tel:' + member_list.mobile" class="btn btn-list">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> Call
                                                </span>
                                            </a>
                                        </li> -->
                                        <li>
                                            <a href="javascript:void(0)" @click="adminView(member_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="pencil-outline"></ion-icon> Edit/Renew
                                                </span>
                                            </a>
                                        </li>
                                        <!-- <li>
                                            <a href="javascript:void(0)" @click="adminDeleteConfirmation(member_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="trash-outline"></ion-icon> Cancel Subscription
                                                </span>
                                            </a>
                                        </li> -->
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> Cancel
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * Default Action Sheet Inset -->
        </div>
    </div>
    
    <!-- 3. പുതിയ നേർപഥം വരി ചേർക്കുക (New Subscription) -->
    <div class="action-cards-container" v-if="!loading_list">
        <div class="action-card">
            <div class="action-card-content">
                <div class="action-card-text">
                    <h6 class="action-card-title">പുതിയ നേർപഥം വരി ചേർക്കുക</h6>
                    <p class="action-card-description">Add a new subscription to your account</p>
                </div>
                <button type="button" @click="adminAdd()" class="btn btn-primary btn-block">
                    <ion-icon name="add-circle-outline"></ion-icon>
                    New Subscription
                </button>
            </div>
        </div>
    </div>
    
    <!-- 4. പ്രശ്നം നേരിടുന്നുണ്ടോ? (Report Issue) -->
    <div class="action-cards-container" v-if="!loading_list && member_lists.data && member_lists.data.length">
        <div class="report-card card-item">
            <div class="report-issue-section">
                <div class="report-issue-text">
                    <ion-icon name="help-circle-outline" class="help-icon"></ion-icon>
                    <div>
                        <h6 class="report-title">പ്രശ്നം നേരിടുന്നുണ്ടോ?</h6>
                        <p class="report-description">Facing any issues? Report them here</p>
                    </div>
                </div>
                <button type="button" @click="openComplaintModal(member_lists.data[0])" 
                        class="btn btn-warning btn-block">
                    <ion-icon name="alert-circle-outline"></ion-icon>
                    Report Issue
                </button>
            </div>
        </div>
    </div>
    
    <!-- 5. Complaint Status Card -->
    <div class="complaints-section" v-if="!loading_list && userComplaints.length > 0">
        <div class="complaints-header">
            <h5 class="complaints-title">
                <ion-icon name="chatbox-ellipses-outline"></ion-icon>
                My Complaints / എന്റെ പരാതികൾ
            </h5>
        </div>
        
        <div class="complaints-list">
            <div class="complaint-card" v-for="complaint in userComplaints" :key="complaint.id">
                <div class="complaint-header">
                    <div class="complaint-type">
                        <ion-icon name="alert-circle-outline" class="complaint-icon"></ion-icon>
                        <h6 class="complaint-title">{{ complaint.issue_type ? complaint.issue_type.name : 'Issue' }}</h6>
                    </div>
                    <span class="badge complaint-status-badge" :class="getComplaintStatusBadgeClass(complaint.status)">
                        {{ complaint.status }}
                    </span>
                </div>
                
                <div class="complaint-date">
                    <ion-icon name="time-outline"></ion-icon>
                    {{ formatDate(complaint.created_at) }}
                </div>
                
                <div class="complaint-details">
                    <p>{{ complaint.issue_details }}</p>
                </div>
                
                <div class="complaint-response" v-if="complaint.comments">
                    <div class="response-header">
                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                        <strong>Response:</strong>
                    </div>
                    <p class="response-text">{{ complaint.comments }}</p>
                </div>
            </div>
        </div>
    </div>
    
    <!-- 6. ഏതെങ്കിലും സഹായത്തിന് (WhatsApp Help) -->
    <div class="action-cards-container" v-if="!loading_list">
        <div class="action-card whatsapp-card">
            <div class="action-card-content">
                <div class="action-card-text">
                    <h6 class="action-card-title">ഏതെങ്കിലും സഹായത്തിന്</h6>
                    <p class="action-card-description">Need help? Contact us on WhatsApp</p>
                </div>
                <a href="https://wa.me/919207965244" target="_blank" class="btn btn-success btn-block">
                    <ion-icon name="logo-whatsapp"></ion-icon>
                    Click Here for Help
                </a>
            </div>
        </div>
    </div>

    <!-- \u003cul class="listview image-listview inset text mt-1 mb-2" v-if="!loading_list && member_lists.total > 0">
        <li v-if="member_lists.data[0].renewal_status != 'Not Requested'">
            <a href="javascript:void(0)" class="item">
                <div class="in" v-if="member_lists.data.length">
                    <div class="min-width-50" style="width:100%;">
                        <b class="text-primary">PAYMENT STATUS</b>
                        <footer class="text-primary">
                            <table style="width:100%;">
                                <tr>
                                    <th>Amount</th>
                                    <th><span
                                            :class="(member_lists.data[0].payments.length ? member_lists.data[0].payments[0].payment_status : '') == 'Paid' ? 'text-success' : 'text-danger'">:
                                            {{ this.amount }} </span></th>
                                    <th rowspan="6" colspan="2">
                                        <ion-icon
                                            v-if="(member_lists.data[0].payments.length ? member_lists.data[0].payments[0].payment_status : '') == 'Paid'"
                                            name="checkmark-circle" style="font-size: 50px;color:#5ecd71;" role="img"
                                            class="md hydrated" aria-label="checkmark circle"></ion-icon>
                                        <ion-icon v-else name="close-circle" style="font-size: 50px;color:#FF396F;"
                                            role="img" class="md hydrated" aria-label="close circle"></ion-icon>
                                    </th>
                                </tr>
                                <tr>
                                    <th>Status</th>
                                    <th><span
                                            :class="(member_lists.data[0].payments.length ? member_lists.data[0].payments[0].payment_status : '') == 'Paid' ? 'text-success' : 'text-danger'">:
                                            {{
                                                member_lists.data[0].payments.length ? member_lists.data[0].payments[0].payment_status:''
                                            }} </span></th>
                                </tr>
                                <tr>
                                    <th>Payment Mode</th>
                                    <th><span class="text-dark">: {{
                                        member_lists.data[0].payments.length ?member_lists.data[0].payments[0].payment_mode:''
                                            }} </span></th>
                                </tr>
                                <tr>
                                    <th>Transaction ID</th>
                                    <th><span class="text-dark">: {{
                                        member_lists.data[0].payments.length ? member_lists.data[0].payments[0].payment_transaction_id : ''
                                            }}</span>
                                    </th>
                                </tr>
                                <tr v-if="member_lists.data[0].payments.length && permissions.print_payment">
                                    <th>Reciept</th>
                                    <th><span class="text-dark">: <a style="font-size: 16px; color: red;" download
                                                :href="'https://guideportal.wisdomislam.org/donation/download-nerpatham-receipt/' + (member_lists.data[0].payments.length ? member_lists.data[0].id : '')">Download</a></span>
                                    </th>
                                </tr>
                                <tr
                                    v-if="(member_lists.data[0].payments.length ? member_lists.data[0].payments[0].payment_status : '') != 'Paid'">
                                    <th>
                                        <button type="button" class="btn btn-danger btn-block btn-sm col mt-1"
                                            @click="razorPay">
                                            <span>Pay Now</span></button>
                                    </th>
                                </tr>
                            </table>
                        </footer>
                    </div>
                </div>
            </a>
        </li>
    </ul> -->
    
    <!-- Complaint Modal -->
    <div class="modal fade action-sheet" id="complaintModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Report Issue / പ്രശ്നം റിപ്പോർട്ട് ചെയ്യുക</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <label class="label" for="issue_type">Issue Type <span class="text-danger">*</span></label>
                            <select class="form-control custom-select" v-model="complaint.issue_type_id" id="issue_type">
                                <option value="">---Select---</option>
                                <option v-for="type in issueTypes" :key="type.id" :value="type.id">
                                    {{ type.name_mal || type.name }}
                                </option>
                            </select>
                        </div>
                        
                        <div class="form-group basic">
                            <label class="label" for="issue_details">Issue Details <span class="text-danger">*</span></label>
                            <textarea class="form-control" v-model="complaint.issue_details" 
                                      id="issue_details" rows="4" 
                                      placeholder="വിശദമായി എഴുതുക..."></textarea>
                        </div>
                        
                        <div class="form-group basic">
                            <label class="label" for="complaint_file">Upload File (Optional)</label>
                            <input type="file" class="form-control" @change="handleComplaintFileUpload" 
                                   id="complaint_file" accept="image/*,application/pdf">
                            <small class="text-muted">Images or PDF files only</small>
                        </div>
                        
                        <div class="form-group" v-if="complaint_message">
                            <div class="error-feedback">{{ complaint_message }}</div>
                        </div>
                        
                        <div class="form-group basic row">
                            <button type="button" @click="submitComplaint" 
                                    class="btn btn-primary btn-block btn-lg col mt-1" 
                                    :disabled="complaint_loading">
                                <span v-show="complaint_loading" class="spinner-border spinner-border-sm"></span>
                                <span>Submit Complaint</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import UserService from "../../services/user.service";
import $ from 'jquery';
import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";
import axios from "axios";
export default {
    name: 'Admin List',
    components: {
        Form,
        Field,
        ErrorMessage,
        AlertModel,
        DialogModel
    },
    props: {
        unit_id: null
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            message: "",
            country_code: '91',
            country_code_whatsapp: '91',
            mobile_number: '',
            whatsapp_number: '',
            wing: '',
            stay: '',
            user_level: "",
            sub_levels: [],
            member_lists: [],
            member_list: [],
            member: [],
            member_edit: true,
            orgnal_member_lists: [],
            trash_list: [],
            unit: [],
            editable_id: '',
            editable: false,
            permissions: [],
            add_admin: false,
            abroad_fields: false,
            pin_number: '',
            attendance: 'A',
            attendance_remarks: '',
            search_qty: '',
            member_id: '',
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            attendance_present: [],
            attendance_absent: [],
            filter_wing: '',
            isMember: '',
            isSubscriber: '',
            receipt_no: '',
            subscription_no: '',
            isEdit: false,
            sub_level_name: '',
            kerala_district_list: [],
            submit_type: '',
            postal_type: 'Postal',
            renewal_btn: false,
            members: [],
            amount: 1,
            name: '',
            phone: '',
            email: '',
            nerpatham_id: '',
            // Complaint related data
            issueTypes: [],
            userComplaints: [],
            complaint: {
                subscription_id: null,
                member_id: null,
                issue_type_id: '',
                issue_details: '',
                file: null
            },
            complaint_loading: false,
            complaint_message: '',
            currentSubscription: null,
            // Payment expansion tracking
            paymentExpanded: {},
            subscriptionExpanded: {},
            profileExpanded: {}
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        minusToZero() {
            let value = this.unit.nerpatham_target - this.member_lists.total;
            if (value <= 0) {
                return '0';
            } else {
                return value;
            }
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/#/login');
        } else {
            this.user_level = parseInt(this.currentUser.user_level);
        }
        this.getMembersList(1);
        this.$root.updateParent('എന്റെ നേർപഥം');

        // this.getComboboxValues('COUNTRY_CODE');
        this.getComboboxValues('DISTRICT_KERALA');
        this.loadIssueTypes(); // Load complaint issue types
        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        toggleProfileDetails(id) {
            // Direct assignment for reactivity
            this.profileExpanded = { ...this.profileExpanded, [id]: !this.profileExpanded[id] };
        },
        togglePaymentDetails(id) {
            // Direct assignment for reactivity
            this.paymentExpanded = { ...this.paymentExpanded, [id]: !this.paymentExpanded[id] };
        },
        toggleSubscriptionDetails(id) {
            // Direct assignment for reactivity
            this.subscriptionExpanded = { ...this.subscriptionExpanded, [id]: !this.subscriptionExpanded[id] };
        },
        razorPay(id) {
            axios
                .post("https://guideportal.wisdomislam.org/api/payment/razorpay", { amount: this.amount })
                .then((res) => {
                    if (res.data) {
                        window.location.href = "https://guideportal.wisdomislam.org/pay/razorpay?key=" + res.data.key +
                            "&amount=" + res.data.amount +
                            "&order_id=" + res.data.order_id +
                            "&email=" + this.email +
                            "&name=" + this.name +
                            "&phone=" + this.phone +
                            "&type=single" +
                            "&nerpatham_id=" + id +
                            "&user_id=" + this.currentUser.id;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleButtonClick(buttonType) {
            this.submit_type = buttonType;
            this.submitForm();
        },
        submitForm() {
            // Use the $refs to access the form and submit it
            this.$refs.myForm.$el.dispatchEvent(new Event('submit'));
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id
            }
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case 'COUNTRY_CODE':
                            this.country_code_list = response.data.data.list.options;
                            break;
                        case "DISTRICT_KERALA":
                            this.kerala_district_list = response.data.data.list.options;
                            break;
                        case 'UNVERIFIED_REASON':
                            this.verification_status_list = response.data.data.list.options;
                            break;

                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        changeMember(member) {
            this.name = member.name;
            this.mobile = member.mobile;
            this.house_name = member.houseName;
            this.pin = parseInt(member.pinCode);
            this.post = member.post;
            this.place = member.place;
            if (member.kerala_district) {
                this.district = member.kerala_district.name;
            }
        },
        getTextList(event, type) {
            this.message = '';
            let data = {
                q: event,
                type: type,
                filter: 'inside',
                unit_id: this.$route.params.id,
                user_level: this.user_level
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminView(admin, type = null) {
            $('#addAdminModel').modal('show');
            this.message = '';
            this.isEdit = true;
            if (admin.member_id) {
                this.member_id = admin.member_id;
                this.member = admin.member;
                this.isMember = 'Y';
                this.disable_member_form = true;
            } else {
                this.isMember = 'N';
                this.disable_member_form = false;
            }
            if (admin.remarks == 'renew') {
                this.isSubscriber = true;
            }
            if (admin.status == 'Requested' || admin.status == 'Requested') {
                this.renewal_btn = false;
            } else {
                this.renewal_btn = true;
            }
            if (type == 'edit') {
                this.renewal_btn = false;
            } else {
                this.renewal_btn = true;
            }

            if (!admin.expiry_date) {
                this.renewal_btn = false;
            }
            this.subscription_no = admin.subscription_no;
            this.receipt_no = admin.reciept_no;
            this.member_edit = false;
            if (admin.member) {
                let member_new = admin.member;
                member_new.text = admin.member.name + '/' + admin.member.mobile;
                member_new.value = admin.member.id;
                this.member_list.push(member_new);
            }
            this.name = admin.name;
            this.mobile = admin.mobile;
            this.house_name = admin.houseName;
            this.pin = parseInt(admin.pinCode);
            this.post = admin.post;
            this.place = admin.place;
            this.district = admin.district;

            this.editable_id = admin.id;
            this.add_admin = false;
            this.edit_admin = true;
        },
        adminAdd() {
            $('#addAdminModel').modal('show');
            this.disable_member_form = false;
            this.message = '';
            this.member_id = '';
            if (this.currentUser.user_level == 6) {
                this.name = this.currentUser.name;
                this.mobile = this.currentUser.phone;
            } else {
                this.name = '';
                this.mobile = '';
            }

            this.house_name = '';
            this.pin = '';
            this.post = '';
            this.place = '';
            this.district = '';
            this.subscription_no = '';
            this.receipt_no = '';
            this.member_edit = true;
            this.member = '';
            this.editable_id = '';
            if (this.members.length == 1 && this.member_lists.data.length == 0) {
                this.changeMember(this.members[0]);
                this.member = this.members[0];
            }
            this.add_admin = true;
            this.edit_admin = false;
        },
        closeAddAdminModel() {
            $('#addAdminModel').modal('hide');
        },
        addAdmin(user) {
            this.loading = true;
            console.log(user);
            user.editable_id = this.editable_id;
            user.is_member = this.isMember;
            user.isSubscriber = this.isSubscriber;
            user.submit_type = this.submit_type;
            if (!this.member && this.isMember == 'Y') {
                this.message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്തതിനു ശേഷം Save അമർത്തുക';
            }
            if (this.member) {
                user.member_id = this.member.id;
            }
            user.unit_id = parseInt(this.$route.params.id);
            user.self = true;
            UserService.addAdmin('store-nerpatham-subscriptions', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addAdminModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1);
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminDeleteConfirmation(admin_list) {
            var data = {
                id: admin_list.id,
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'adminDelete';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        adminDelete(data) {
            UserService.authPostRequest('delate-nerpatham-subscriptions', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1);
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getWing(wing) {
            if (wing == 1)
                return 'വിസ്‌ഡം';
            else if (wing == 2)
                return 'യൂത്ത്';
            else if (wing == 3)
                return 'സ്റ്റുഡന്റസ്';
            else if (wing == 4)
                return 'വിമെൻ';
            else
                return 'ഗേൾസ്';
        },
        getMembersList(page = 1) {
            this.loading_list = true;
            let data = {
                user_level: this.user_level,
                unit_id: parseInt(this.$route.params.id),
                self: true
            }
            UserService.authPostRequest(`get-nerpatham-subscriptions?page=${page}`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.members = response.data.data.members;
                        this.permissions = response.data.data.permissions;
                        this.member_lists = response.data.data.list;
                        this.search_qty = '';
                        this.orgnal_member_lists = response.data.data.list.data;
                        this.unit = response.data.data.unit;
                        this.$root.updateParent('എന്റെ നേർപഥം');
                        this.loading_list = false;
                        this.amount = response.data.data.amount_to_paid ? response.data.data.amount_to_paid : 1;
                        if (this.member_lists.data.length) {
                            this.phone = this.member_lists.data[0].mobile;
                            this.nerpatham_id = this.member_lists.data[0].id;
                            this.user_id = this.currentUser.id;
                            this.name = this.member_lists.data[0].name;
                            this.email = this.member_lists.data[0].email ? this.member_lists.data[0].email : 'no-email@wisdomislam.org';
                            // Initialize all profiles as collapsed by default
                            const expanded = {};
                            this.member_lists.data.forEach(member => {
                                expanded[member.id] = false; // Changed from true to false
                            });
                            this.profileExpanded = expanded;
                            // Load user complaints
                            this.loadUserComplaints();
                        }
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        downloadBiodata(member_list) {
            let data = {
                id: member_list.id
            }
            UserService.authPostRequest('download-member-pdf', data).then(
                (response) => {
                    if (response) {
                        // let blob = new Blob([response], {
                        //     type: 'application/pdf'
                        // })
                        // let link = document.createElement('a')
                        // link.href = response.data.data.link
                        // link.setAttribute('download', 'file.pdf');
                        // link.click()

                        // window.open(response.data.data.link)

                        const link = document.createElement('a');
                        link.href = response.data.data.link
                        link.setAttribute('download', member_list.name + ' biodata-form.pdf'); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        this.loading = false;
                    } else {
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        goToBiodata(member_list) {
            this.$router.push('/bio-data/' + member_list.user_id);
        },
        showActionModel() {
            this.pin_number = '';
        },
        attendanceOpen(member) {
            this.member_id = member.id;
            this.attendance = member.attendance.attendance != 'N' ? member.attendance.attendance : 'A';
            this.attendance_remarks = member.attendance.leave_reason;
            $('#attendanceModel').modal('show');
        },
        markAttandance() {
            let data = {
                member_id: this.member_id,
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.sub_level),
                attendance: this.attendance,
                remarks: this.attendance_remarks
            }
            this.loading = true;
            UserService.authPostRequest('mark-attendance', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#attendanceModel').modal('hide');
                        if (this.attendance == "P") {
                            this.attendance_present.push(this.member_id);
                            const index = this.attendance_absent.indexOf(this.member_id);
                            if (index > -1) { // only splice array when item is found
                                this.attendance_absent.splice(index, 1); // 2nd parameter means remove one item only
                            }
                        } else {
                            this.attendance_absent.push(this.member_id);
                            const index = this.attendance_present.indexOf(this.member_id);
                            if (index > -1) { // only splice array when item is found
                                this.attendance_present.splice(index, 1); // 2nd parameter means remove one item only
                            }
                        }

                        console.log(this.attendance_absent);

                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.data.message;
                    this.$refs.alert_model.openModel();
                }
            );

        },
        filteredMembers() {
            // this.loading_list = true;
            // let filter_list = this.orgnal_member_lists;
            // filter_list = filter_list.filter((samsung) => {
            //     return this.search_qty.toLowerCase().split(' ').every(v => samsung.member.name.toLowerCase().includes(v)) || this.search_qty.toLowerCase().split(' ').every(v => samsung.member.mobile.toLowerCase().includes(v));
            // });
            // this.member_lists = filter_list;
            this.loading_list = false;
        },
        // async createOrder() {
        //     try {
        //         const response = await this.$axios.post('/create-razorpay-order', {
        //             amount: this.amount
        //         });
        //         if (response.data.order_id) {
        //             this.orderId = response.data.order_id;
        //             this.amount = response.data.amount;
        //         } else {
        //             alert('Error creating order');
        //         }
        //     } catch (error) {
        //         console.error('Error creating Razorpay order:', error);
        //     }
        // },
        // // Open Razorpay payment gateway
        // async openRazorpayPayment() {
        //     await this.createOrder();

        //     const options = {
        //         key: 'rzp_live_UUjmsncY62dq7Q', // Your Razorpay API Key
        //         amount: this.amount * 100, // Amount in paise (1 INR = 100 paise)
        //         currency: 'INR',
        //         order_id: this.orderId, // Order ID created from backend
        //         name: 'Nerpatham',
        //         description: 'Nerpatham Subscription',
        //         image: 'https://example.com/logo.png', // Optional, your company logo
        //         handler: (response) => {
        //             // Payment success handler
        //             console.log('Payment success', response);
        //             // Call your backend to verify the payment and update the status
        //             this.$axios.post('/verify-payment', {
        //                 paymentId: response.razorpay_payment_id,
        //                 orderId: response.razorpay_order_id,
        //                 signature: response.razorpay_signature
        //             }).then((verifyResponse) => {
        //                 alert('Payment verified successfully'+verifyResponse);
        //             }).catch((err) => {
        //                 console.error('Payment verification failed', err);
        //             });
        //         },
        //         prefill: {
        //             name: 'Customer Name',
        //             email: 'customer@example.com',
        //             contact: '1234567890'
        //         },
        //         notes: {
        //             address: 'Customer Address'
        //         },
        //         theme: {
        //             color: '#F37254'
        //         }
        //     };

        //     const razorpayInstance = new window.Razorpay(options);
        //     razorpayInstance.open();
        // }
        
        // Complaint Methods
        loadIssueTypes() {
            UserService.authPostRequest('get-nerpatham-issue-types', {}).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.issueTypes = response.data.data.issue_types;
                    }
                },
                (error) => {
                    console.error('Error loading issue types:', error);
                }
            );
        },
        
        loadUserComplaints() {
            if (this.member_lists.data && this.member_lists.data.length > 0) {
                const subscriptionId = this.member_lists.data[0].id;
                UserService.authPostRequest('get-nerpatham-complaints', {
                    subscription_id: subscriptionId
                }).then(
                    (response) => {
                        if (response.data.status === 'success') {
                            this.userComplaints = response.data.data.complaints.data || [];
                        }
                    },
                    (error) => {
                        console.error('Error loading complaints:', error);
                    }
                );
            }
        },
        
        openComplaintModal(subscription) {
            this.currentSubscription = subscription;
            this.complaint.subscription_id = subscription.id;
            this.complaint.member_id = subscription.member_id;
            this.complaint.issue_type_id = '';
            this.complaint.issue_details = '';
            this.complaint.file = null;
            this.complaint_message = '';
            $('#complaintModal').modal('show');
        },
        
        closeComplaintModal() {
            $('#complaintModal').modal('hide');
            this.resetComplaintForm();
        },
        
        handleComplaintFileUpload(event) {
            this.complaint.file = event.target.files[0];
        },
        
        submitComplaint() {
            // Validation
            if (!this.complaint.issue_type_id) {
                this.complaint_message = 'Please select an issue type';
                return;
            }
            
            if (!this.complaint.issue_details) {
                this.complaint_message = 'Please provide issue details';
                return;
            }
            
            this.complaint_loading = true;
            this.complaint_message = '';
            
            const formData = new FormData();
            formData.append('subscription_id', this.complaint.subscription_id);
            if (this.complaint.member_id) {
                formData.append('member_id', this.complaint.member_id);
            }
            formData.append('issue_type_id', this.complaint.issue_type_id);
            formData.append('issue_details', this.complaint.issue_details);
            
            if (this.complaint.file) {
                formData.append('file', this.complaint.file);
            }
            
            UserService.authPostRequest('store-nerpatham-complaint', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(
                (response) => {
                    this.complaint_loading = false;
                    if (response.data.status === 'success') {
                        $('#complaintModal').modal('hide');
                        this.alert_type = 'Success';
                        this.alert_message = 'Complaint submitted successfully!';
                        this.$refs.alert_model.openModel();
                        this.resetComplaintForm();
                        this.loadUserComplaints();
                    } else {
                        this.complaint_message = response.data.message || 'Failed to submit complaint';
                    }
                },
                (error) => {
                    this.complaint_loading = false;
                    this.complaint_message = (error.response && 
                        error.response.data && 
                        error.response.data.message) || 
                        error.message || 
                        'Failed to submit complaint';
                }
            );
        },
        
        resetComplaintForm() {
            this.complaint = {
                subscription_id: null,
                member_id: null,
                issue_type_id: '',
                issue_details: '',
                file: null
            };
            this.complaint_message = '';
            // Reset file input
            const fileInput = document.getElementById('complaint_file');
            if (fileInput) {
                fileInput.value = '';
            }
        },
        
        getComplaintStatusClass(status) {
            const statusClasses = {
                'Pending': 'text-warning',
                'In Progress': 'text-info',
                'Resolved': 'text-success',
                'Closed': 'text-secondary'
            };
            return statusClasses[status] || 'text-dark';
        },
        
        getComplaintStatusBadgeClass(status) {
            const statusClasses = {
                'Pending': 'badge-warning',
                'In Progress': 'badge-info',
                'Resolved': 'badge-success',
                'Closed': 'badge-secondary'
            };
            return statusClasses[status] || 'badge-secondary';
        },
        
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
    },
};
</script>
<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.listview {
    /* margin-bottom: 20px; */
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.wallet-card {
    padding-bottom: 0px !important;

}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
}

.pagination-container {
    display: flex;
    column-gap: 10px;
}

.paginate-buttons {
    height: 40px;
    width: 40px;
    border-radius: 20px;
    cursor: pointer;
    background-color: rgb(242, 242, 242);
    border: 1px solid rgb(217, 217, 217);
    color: black;
}

.paginate-buttons:hover {
    background-color: #d8d8d8;
}

.active-page {
    background-color: #3498db;
    border: 1px solid #3498db;
    color: white;
}

.active-page:hover {
    background-color: #2988c8;
}

/* Subscription Card Styling */
.subscription-cards-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px; /* Reduced gap for more compact layout */
    padding: 16px 16px 0px 16px; /* Added top padding for spacing from header */
}

.card-item {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.profile-card {
    margin-bottom: 0;
}

.profile-header-toggle {
    cursor: pointer;
    padding: 16px;
    background-color: #fff;
    transition: background-color 0.2s;
    border-bottom: 2px solid #e0e0e0;
}

.profile-header-toggle:hover {
    background-color: #f8f9fa;
}

.header-content-expanded {
    width: 100%;
}

.header-top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.header-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
}

.subscription-number {
    color: #1a73e8;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
    text-align: left;
    width: 100%;
}

.subscriber-name {
    color: #202124;
    font-size: 18px;
    font-weight: 700;
    margin: 0;
    text-align: left;
    width: 100%;
}

.header-subscription-details {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 8px;
}

.header-subscription-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 4px;
    margin-top: 8px;
    font-size: 13px;
}

.grid-item {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0; /* Allows text truncation if needed, prevents overflow */
}

.header-detail-inline {
    display: flex;
    align-items: center;
    gap: 4px;
}

.header-detail-separator {
    color: #dadce0;
    font-weight: bold;
    padding: 0 4px;
}

.badge-sm {
    font-size: 11px;
    padding: 3px 8px;
}

.header-detail-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 120px;
}

.header-detail-label {
    font-size: 12px;
    color: #5f6368;
    font-weight: 500;
}

.header-detail-value {
    font-size: 14px;
    color: #202124;
    font-weight: 600;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-chevron-icon {
    font-size: 24px;
    color: #1a73e8;
    transition: transform 0.3s;
    flex-shrink: 0;
}

.profile-content {
    padding: 16px;
}

.subscription-header {
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 2px solid #e0e0e0;
}

.subscription-number {
    color: #1a73e8;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
}

.subscriber-name {
    color: #202124;
    font-size: 18px;
    font-weight: 700;
    margin: 0;
}

/* Report Card Styling */
.report-card {
    padding: 16px;
}

/* Payment Card Styling */
.payment-card {
    padding: 0;
}

.info-section {
    margin-bottom: 16px;
    padding: 12px;
    background-color: #f8f9fa;
    border-radius: 8px;
}

.section-title {
    font-size: 14px;
    font-weight: 600;
    color: #5f6368;
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.info-grid {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
}

.info-label {
    font-size: 14px;
    color: #5f6368;
    font-weight: 500;
    flex: 0 0 40%;
}

.info-value {
    font-size: 14px;
    color: #202124;
    font-weight: 600;
    flex: 1;
    text-align: right;
}

.badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

.badge-success {
    background-color: #d4edda;
    color: #155724;
}

.badge-warning {
    background-color: #fff3cd;
    color: #856404;
}

.badge-danger {
    background-color: #f8d7da;
    color: #721c24;
}

.action-section {
    margin-bottom: 12px;
}

.button-group {
    display: flex;
    gap: 8px;
}

.button-group .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 13px;
    padding: 10px 16px;
}

.button-group ion-icon {
    font-size: 16px;
}

.payment-section {
    background-color: #fff;
    border: 1px solid #e0e0e0;
}

.payment-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
}

.payment-info {
    flex: 1;
}

.payment-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.payment-status-icon {
    font-size: 48px;
}

.payment-status-icon.success {
    color: #5ecd71;
}

.payment-status-icon.danger {
    color: #FF396F;
}

.payment-action {
    margin-top: 12px;
}

.payment-action .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-weight: 600;
}

.btn-block {
    width: 100%;
}

.btn ion-icon {
    vertical-align: middle;
}

/* Responsive adjustments */
@media (max-width: 576px) {
    .subscription-card-content {
        padding: 12px;
    }
    
    .info-label {
        flex: 0 0 45%;
        font-size: 13px;
    }
    
    .info-value {
        font-size: 13px;
    }
    
    .payment-content {
        flex-direction: column-reverse;
        align-items: center;
    }
    
    .payment-icon {
        margin-bottom: 12px;
    }
}

/* Action Cards Styling */
.action-cards-container {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.action-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s;
}

.action-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.action-card-content {
    padding: 20px;
}

.action-card-text {
    margin-bottom: 16px;
}

.action-card-title {
    font-size: 16px;
    font-weight: 700;
    color: #202124;
    margin-bottom: 4px;
}

.action-card-description {
    font-size: 13px;
    color: #5f6368;
    margin: 0;
}

.action-card .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-weight: 600;
    padding: 12px 24px;
    font-size: 15px;
}

.action-card .btn ion-icon {
    font-size: 20px;
}

.whatsapp-card {
    border: 2px solid #25D366;
}

.whatsapp-card .btn-success {
    background-color: #25D366;
    border-color: #25D366;
}

.whatsapp-card .btn-success:hover {
    background-color: #128C7E;
    border-color: #128C7E;
}

/* Complaints Section Styling */
.complaints-section {
    padding: 16px;
    margin-top: 16px;
}

.complaints-header {
    margin-bottom: 16px;
}

.complaints-title {
    font-size: 18px;
    font-weight: 700;
    color: #202124;
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
}

.complaints-title ion-icon {
    font-size: 24px;
    color: #1a73e8;
}

.complaints-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.complaint-card {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    border-left: 4px solid #1a73e8;
}

.complaint-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
    gap: 12px;
}

.complaint-type {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
}

.complaint-icon {
    font-size: 20px;
    color: #1a73e8;
    flex-shrink: 0;
}

.complaint-title {
    font-size: 16px;
    font-weight: 700;
    color: #202124;
    margin: 0;
}

.complaint-status-badge {
    flex-shrink: 0;
}

.complaint-date {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #5f6368;
    margin-bottom: 12px;
}

.complaint-date ion-icon {
    font-size: 14px;
}

.complaint-details {
    margin-bottom: 12px;
}

.complaint-details p {
    font-size: 14px;
    color: #202124;
    line-height: 1.5;
    margin: 0;
}

.complaint-response {
    background-color: #e8f5e9;
    border-radius: 8px;
    padding: 12px;
    margin-top: 12px;
}

.response-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    color: #2e7d32;
}

.response-header ion-icon {
    font-size: 18px;
}

.response-text {
    font-size: 13px;
    color: #1b5e20;
    margin: 0;
    line-height: 1.5;
}

/* Additional Badge Variants */
.badge-info {
    background-color: #d1ecf1;
    color: #0c5460;
}

.badge-secondary {
    background-color: #e2e3e5;
    color: #383d41;
}

/* Responsive for Action Cards and Complaints */
@media (max-width: 576px) {
    .action-cards-container,
    .complaints-section {
        padding: 12px;
    }
    
    .action-card-content {
        padding: 16px;
    }
    
    .complaint-card {
        padding: 12px;
    }
    
    .complaint-header {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .complaint-status-badge {
        align-self: flex-start;
    }
}

/* Report Issue Section Styling - Adjusted for Services Card */
.report-issue-section {
    margin-bottom: 0;
    padding: 16px 0 16px 0;
}

.report-issue-text {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;
}

.help-icon {
    font-size: 28px;
    color: #f57c00;
    flex-shrink: 0;
    margin-top: 2px;
}

.report-title {
    font-size: 15px;
    font-weight: 700;
    color: #e65100;
    margin: 0 0 4px 0;
}

.report-description {
    font-size: 13px;
    color: #5f6368;
    margin: 0;
}

.report-issue-section .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-weight: 600;
}

/* Payment Section Wrapper - Collapsible */
.payment-section-wrapper {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e0e0e0;
    background-color: #fff;
}

.subscription-toggle {
    cursor: pointer;
    padding: 14px 16px;
    background-color: #f8f9fa;
    transition: background-color 0.2s;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.subscription-toggle:hover {
    background-color: #e9ecef;
}

.subscription-toggle {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
}

.subscription-content {
    padding: 8px 0;
}

/* Compact Payment Card Styles */
.compact-payment-card {
    background-color: #f8f9fa;
    border-radius: 10px;
    padding: 16px;
    border: 1px solid #e0e0e0;
}

.compact-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.payment-icon-main {
    font-size: 18px;
    color: #1a73e8;
}

.payment-title {
    font-size: 14px;
    font-weight: 700;
    color: #202124;
}

.amount-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 8px;
    border-bottom: 1px dashed #ced4da;
    margin-bottom: 10px;
}

.amount-label {
    font-size: 14px;
    color: #5f6368;
    font-weight: 500;
}

.amount-value {
    font-size: 16px;
    font-weight: 700;
}

.detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
    font-size: 13px;
}

.detail-label {
    color: #5f6368;
}

.detail-value {
    font-weight: 500;
    color: #3c4043;
    max-width: 60%;
    text-align: right;
    word-break: break-all;
}

/* Services Card Container */
.services-card {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive adjustments for new sections */
@media (max-width: 576px) {
    .report-issue-section {
        padding: 12px 0;
    }
    
    .report-issue-text {
        gap: 10px;
    }
    
    .help-icon {
        font-size: 24px;
    }
    
    .payment-toggle, .subscription-toggle {
        padding: 12px;
    }
    
    .payment-details {
        padding: 12px;
    }
    
    .payment-details .payment-content {
        flex-direction: column-reverse;
        align-items: center;
    }
    
    .payment-details .payment-icon {
        margin-bottom: 12px;
    }
    
    .services-card {
        padding: 12px;
    }
}

</style>